const tofixeds =  function(value) {
  if (value === undefined || value === null) {
    return "";
  }
  let realVal = parseFloat(value).toFixed(2)
  return realVal
};

const tofixedsOne =  function(value) {
  if (value === undefined || value === null) {
    return "";
  }
  let realVal = parseFloat(value).toFixed(1)
  return realVal
};
const sswr =  function(value) {
  if (value === undefined || value === null) {
    return "";
  }
  return Math.ceil(value);
};
const tofloor=function(value){
  if (value === undefined || value === null) {
    return "";
  }
  return Math.floor(value);
}
const toDate = function (val) {
  if (val === undefined || val === null) {
    return "";
  }
  return new Date(val).format( 'yyyy-MM-dd');
};

const toTime = function (val) {
  if (val === undefined || val === null) {
    return "";
  }
  return new Date(val).format('yyyy-MM-dd hh:mm:ss');
};
const toTimeStart = function (val) {
  if (val === undefined || val === null) {
    return "";
  }
  return new Date(val).format('yyyy-MM-dd 00:00:00');
};
const toTimeEnd = function (val) {
  if (val === undefined || val === null) {
    return "";
  }
  return new Date(val).format('yyyy-MM-dd 23:59:59');
};
const toDateHHMM = function (val) {
  if (val === undefined || val === null) {
    return "";
  }
  return new Date(val).format('yyyy-MM-dd hh:mm');
};

const toDateDot = function (val) {
  if (val === undefined || val === null) {
    return "";
  }
  if(AX_DATE_TIME <= val) return "永久";
  return new Date(val).format( 'yyyy.MM.dd');
};
// 获取近一周一月今天得时间
const getDateRange = function (dateNow,intervalDays,bolPastTime){
  let oneDayTime = 24 * 60 * 60 * 1000;
  let list = [];
  let lastDay;

  if(bolPastTime == true){
    lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime);
    list.push(this.formateDate(lastDay));
    list.push(this.formateDate(dateNow));
  }else{
    lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime);
    list.push(this.formateDate(dateNow));
    list.push(this.formateDate(lastDay));
  }
  return list;
};
const formateDate= function (time){
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let day = time.getDate()
  if (month < 10) {
    month = '0' + month
  }

  if (day < 10) {
    day = '0' + day
  }
  return year + '-' + month + '-' + day + ''

};
const getNowFormatDate2=function (date2)  {
  var date = date2;
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
const toInt =  function(value) {
  if (value === undefined || value === null) {
    return 0;
  }
  return value;
};
export default {
  toInt,
  tofixeds,
  tofloor,
  toDate,
  toDateDot,
  toTime,
  toTimeStart,
  toTimeEnd,
  getDateRange,
  formateDate,
  toDateHHMM,
  tofixedsOne,
  sswr,
  getNowFormatDate2
}



// WEBPACK FOOTER //
// ./src/utils/filters.js